import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { Outlet, useNavigate } from "react-router-dom";
import { useStore } from './store';
import { useLiveQuery } from 'dexie-react-hooks';
import Header from './Components/elements/Header';
import Footer from './Components/elements/Footer';

import 'react-datasheet-grid/dist/style.css'
import SRFButton from './Components/Inputs/SRFButton/SRFButton';
import { pFetch } from './Utils/Functions/helpers';
import AuthPage from './Components/Pages/Auth';
import LoadingOverlay from './Components/elements/LoadingOverlay/LoadingOverlay';

const appTitle = "Field Reports";

function App() {
  const navigate = useNavigate();
  const {isAuthed, isOnline, isSubmitting} = useStore();

  useEffect(() => {
    if(!isAuthed) {
      navigate("/auth");
    } 
  }, [isAuthed, isOnline])
  return (
    <div className="min-h-screen flex flex-col">
      {isSubmitting && <LoadingOverlay />}
      <Header appTitle={appTitle} />
      <div className="min-h-[85vh] flex flex-col">
        <Outlet />
      </div>
      <Footer appTitle={appTitle} />
    </div>
  );
}

export default App;


